type DebouncedFn<T extends (...args: any[]) => void> = T & { clear: () => void }

export const debounce = <T extends (...args: any[]) => void>(fn: T, ms: number): DebouncedFn<T> => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined
  const debounced = (...args: Parameters<T>) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn(...args), ms)
  }
  debounced.clear = () => clearTimeout(timeoutId)
  return debounced as DebouncedFn<T>
}
